import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';
import type { ReactNode } from 'react';

/**
 * Repeatable eyebrow + H2 + subhead used across marketing sections. Keeps
 * type scale consistent so no section drifts to its own H2 size and breaks
 * the vertical rhythm.
 */
export interface SectionHeaderProps {
  eyebrow?: string;
  headline: ReactNode;
  subhead?: ReactNode;
  align?: 'center' | 'left';
}

export function SectionHeader({
  eyebrow,
  headline,
  subhead,
  align = 'center',
}: SectionHeaderProps): ReactNode {
  const textAlign = align === 'center' ? 'center' : 'left';
  const maxWidth = align === 'center' ? 720 : undefined;
  const marginX = align === 'center' ? 'auto' : undefined;
  return (
    <div style={{ textAlign, maxWidth, marginLeft: marginX, marginRight: marginX }}>
      <SpaceBetween size="s">
        {eyebrow ? (
          <div>
            <span
              style={{
                display: 'inline-block',
                padding: '4px 12px',
                fontSize: 12,
                fontWeight: 600,
                letterSpacing: 0.4,
                textTransform: 'uppercase',
                color: '#6366f1',
                background: 'rgba(99, 102, 241, 0.08)',
                border: '1px solid rgba(99, 102, 241, 0.25)',
                borderRadius: 999,
              }}
            >
              {eyebrow}
            </span>
          </div>
        ) : null}
        <div style={{ fontSize: 40, fontWeight: 700, lineHeight: 1.15, letterSpacing: -0.5 }}>
          {headline}
        </div>
        {subhead ? (
          <Box color="text-body-secondary" fontSize="heading-s">
            {subhead}
          </Box>
        ) : null}
      </SpaceBetween>
    </div>
  );
}
